/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { FlexColumn, Typography } from 'design-system';

export default function GuidanceStepHeader({
  label,
  title,
  instruction,
  labelVariant = 'bodyExtraSmall',
  titleVariant = 'headingMedium',
  titleFontWeight = 'semibold',
}) {
  return (
    <FlexColumn align="start" fullWidth gap="var(--ds-space-2)">
      <Typography
        component="p"
        variant={labelVariant}
        fontWeight="semibold"
        className="ld-guidance-step__label"
      >
        {label}
      </Typography>
      <Typography
        component="h1"
        variant={titleVariant}
        fontWeight={titleFontWeight}
        color="ui-emphasis"
      >
        {title}
      </Typography>
      <Typography component="p" variant="bodyMedium" color="ui-subtle">
        {instruction}
      </Typography>
    </FlexColumn>
  );
}

GuidanceStepHeader.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  instruction: PropTypes.string.isRequired,
  labelVariant: PropTypes.string,
  titleVariant: PropTypes.string,
  titleFontWeight: PropTypes.string,
};
